import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

import { RtudataStore } from '@modules/rtudata/rtudata.store';

type ReportType = 'fertilizing' | 'sapling' | 'seed' | 'spraying';

@Component({
  imports: [MatDialogModule],
  selector: 'norupe-report-detail-dialog',
  template: `
    <h2 mat-dialog-title>{{ data.report_title }}</h2>
    <mat-dialog-content>
      @switch (reportType) {
        @case ('fertilizing') {
          <div class="mb-3 text-sm">
            <span class="font-medium">Mēslojuma nosaukums:</span>
            {{ data.fertilizer_name || '—' }}
          </div>
        }
        @case ('spraying') {
          <div class="mb-3 text-sm">
            <span class="font-medium">Pesticīda nosaukums:</span>
            {{ data.pesticide_name || '—' }}
          </div>
        }
      }
      @switch (reportType) {
        @case ('sapling') {
          <table class="w-full text-sm">
            <thead>
              <tr>
                <th class="px-2 py-1 text-left font-medium text-gray-700">
                  Suga
                </th>
                <th class="px-2 py-1 text-center font-medium text-gray-700">
                  Standarta
                </th>
                <th class="px-2 py-1 text-center font-medium text-gray-700">
                  Nestandarta
                </th>
                <th class="px-2 py-1 text-center font-medium text-gray-700">
                  Brāķis
                </th>
              </tr>
            </thead>
            <tbody>
              @for (species of rtuDataStore.treespecies(); track species.id) {
                @let key = species.value.toLowerCase().replace('ē', 'e');
                <tr class="border-t">
                  <td class="px-2 py-1">{{ species.value }}</td>
                  <td class="px-2 py-1 text-center">
                    {{ data[key + '_std'] ?? 0 }}
                  </td>
                  <td class="px-2 py-1 text-center">
                    {{ data[key + '_nonstd'] ?? 0 }}
                  </td>
                  <td class="px-2 py-1 text-center">
                    {{ data[key + '_defect'] ?? 0 }}
                  </td>
                </tr>
              }
            </tbody>
          </table>
        }
        @default {
          <table class="w-full text-sm">
            <thead>
              <tr>
                <th class="px-2 py-1 text-left font-medium text-gray-700">
                  Suga
                </th>
                <th class="px-2 py-1 text-center font-medium text-gray-700">
                  Daudzums
                </th>
              </tr>
            </thead>
            <tbody>
              @for (species of rtuDataStore.treespecies(); track species.id) {
                @let key = species.value.toLowerCase().replace('ē', 'e');
                <tr class="border-t">
                  <td class="px-2 py-1">{{ species.value }}</td>
                  <td class="px-2 py-1 text-center">{{ data[key] ?? 0 }}</td>
                </tr>
              }
            </tbody>
          </table>
        }
      }
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close type="button">Aizvērt</button>
    </mat-dialog-actions>
  `,
})
export class ReportDetailDialogComponent {
  readonly data = inject(MAT_DIALOG_DATA);
  readonly rtuDataStore = inject(RtudataStore);

  reportType!: ReportType;

  constructor() {
    const url: string = this.data.report_url ?? '';
    if (url.includes('fertilizing')) {
      this.reportType = 'fertilizing';
    } else if (url.includes('sapling')) {
      this.reportType = 'sapling';
    } else if (url.includes('seed')) {
      this.reportType = 'seed';
    } else if (url.includes('spraying')) {
      this.reportType = 'spraying';
    }
  }
}
